module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/$.a-function.js
// module id = 1146
// module chunks = 0